export enum PracticeTabs {
  Editor = 'editor',
  Tests = 'tests',
  Browser = 'browser',
  TaskSolution = 'task-solution',
}
